/* yz-variant-fix.js */
(function () {
  'use strict';

  // Ocultar elementos no deseados
  var style = document.createElement('style');
  style.textContent = [
    '.yz-recently-viewed { display: none !important; }',
    '.frequently-bought-together .variant-select { display: none !important; }',
    '.frequently-bought-together select { display: none !important; }'
  ].join(' ');
  document.head.appendChild(style);

  if (!window.location.pathname.includes('/products/')) return;

  function restoreVariantInputs() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
    if (!fieldsets.length) return;
    var anchor = vs.querySelector('script[type="application/json"]') || null;
    var movido = false;
    fieldsets.forEach(function (fs) {
      if (!vs.contains(fs)) { vs.insertBefore(fs, anchor); movido = true; }
    });
    // El `change` solo hace falta si se ha recolocado algun selector. Lanzarlo siempre
    // obligaba al tema a pedir dos veces la seccion entera y a repintar la foto
    // principal tras la carga: el LCP pasaba de ~3,5 s a ~6,7 s (medido el 21-sep).
    if (!movido) return;
    var checked = vs.querySelector('input[type="radio"]:checked');
    if (checked) { checked.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(restoreVariantInputs, 350); });
  } else {
    setTimeout(restoreVariantInputs, 350);
  }
})();

/* yz-urgencia-persist: RETIRADO el 21-sep. El widget («N personas viendo», «solo quedan N»)
   ya estaba oculto por CSS desde la decision del 15-sep de quitar la presion, pero seguia
   construyendose y vigilando todo el documento con un MutationObserver en cada ficha. */
